import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getCurrentDate({ commit }) {
    return GraphQlClient.query(`
    query {
      currentDate {
        currentTimestamp
      }
    }
    `)
    .then((res = {}) => {
      const { data = {} } = res;
      const { currentDate } = data;
      const { currentTimestamp } = currentDate;
      commit('setCurrentDate', Number(currentTimestamp));
      return Number(currentTimestamp);
    })
    .catch(err => Promise.reject(err));
  },
};



// WEBPACK FOOTER //
// ./src/stores/date/actions.js